// extracted by mini-css-extract-plugin
module.exports = {"newCard":"addNewCard_newCard__Lij6p","cardIcon":"addNewCard_cardIcon__atFFg","chevron":"addNewCard_chevron__SFV3t"};